import './style.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('catalog-filter-range', () => import(/* webpackMode: "lazy" */'./catalog-filter-range'));
